export default function dollarsToCents(value?: number | string | null): number {
  return Math.round(Number(value || 0) * 100);
}
